import type { ToolApprovalCardProps } from "#components/ui/tool-approval/renderers/ToolApprovalRenderer.types.ts";
import { availabilityExpiry, availabilityLine, formatEventTime, overlappingInvite } from "#features/conversations/components/prepared-action/calendarEventFields.ts";
import { useNowUntilExpiry } from "#features/conversations/hooks/useNowUntilExpiry.ts";
import { readString } from "#features/conversations/lib/untypedFields.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Text } from "@hopper-ui/components";
import { IconCircleCheckFill, IconTriangleExclamation } from "@intentui/icons";

// One invite in a batch's list: its title and time, then whether its attendees are free and nothing else in the batch overlaps.
export function CalendarInviteRow({ args, display, edits, siblings = [] }: Pick<ToolApprovalCardProps, "args" | "display" | "edits" | "siblings">) {
    const { tShared, i18n } = useSharedTranslation();
    const shown = { ...args, ...edits };
    const when = formatEventTime(shown, i18n.language);
    const fields = display ?? {};
    const now = useNowUntilExpiry(availabilityExpiry(fields));
    const availability = availabilityLine(fields, tShared, i18n.language, now, overlappingInvite(shown, siblings));
    const Glyph = availability?.isClear ? IconCircleCheckFill : IconTriangleExclamation;

    return (
        <div className="wai-ce-invite-row">
            <Text size="sm">
                <Text size="sm" fontWeight="body-sm-semibold" color="neutral">{readString(shown, "subject")}</Text>
                {when !== null && <Text size="sm" className="wai-pa-muted"> · {when}</Text>}
            </Text>
            {availability !== null && (
                <span className={availability.isClear ? "wai-ce-invite-status is-clear" : "wai-ce-invite-status"}>
                    <Glyph aria-hidden="true" />
                    <Text size="xs" className="wai-pa-muted" role="status">{availability.text}</Text>
                </span>
            )}
        </div>
    );
}
